import {
  createCMSCollectionManifest,
  createCMSCollectionFieldManifest,
  createCMSCollectionItemsManifest,
  createWebhookManifest,
  deleteWebhookManifest,
  enableFunctionsCmsAccessManifest,
  checkFunctionsCmsAccessManifest,
  extractSiteStylesTool,
  getCMSCollectionDetailsManifest,
  getCMSCollectionItemDetailsManifest,
  getPageMetadataManifest,
  getSiteInfoManifest,
  listCMSCollectionItemsManifest,
  listCMSCollectionsManifest,
  listPagesManifest,
  listWebhooksManifest,
  publishCMSCollectionItemsManifest,
  readReferenceFileManifest,
  searchKnowledgeBaseManifest,
  updateCMSCollectionManifest,
  updateCMSCollectionFieldManifest,
  updateCMSCollectionItemsManifest,
  updatePageMetadataManifest,
  searchVariablesManifest,
  type ToolRegistryItem,
  listTranslationExclusionsManifest,
  createTranslationExclusionsManifest,
  deleteTranslationExclusionsManifest,
  listTargetLanguagesManifest,
  bulkUpdateTranslationExclusionsManifest,
  updateAllMatchingTranslationExclusionsManifest,
  deleteAllMatchingTranslationExclusionsManifest,
  listSiteComponentsManifest,
  getComponentPropertiesManifest,
} from '@packages/systems/ai/tool-registry/shared';

export const serverToolsMap: Partial<
  Record<ToolRegistryItem['id'], ToolRegistryItem>
> = {
  [createCMSCollectionManifest.id]: createCMSCollectionManifest,
  [createCMSCollectionFieldManifest.id]: createCMSCollectionFieldManifest,
  [createCMSCollectionItemsManifest.id]: createCMSCollectionItemsManifest,
  [createTranslationExclusionsManifest.id]: createTranslationExclusionsManifest,
  [createWebhookManifest.id]: createWebhookManifest,
  [deleteTranslationExclusionsManifest.id]: deleteTranslationExclusionsManifest,
  [deleteWebhookManifest.id]: deleteWebhookManifest,
  [enableFunctionsCmsAccessManifest.id]: enableFunctionsCmsAccessManifest,
  [checkFunctionsCmsAccessManifest.id]: checkFunctionsCmsAccessManifest,
  [extractSiteStylesTool.id]: extractSiteStylesTool,
  [getCMSCollectionDetailsManifest.id]: getCMSCollectionDetailsManifest,
  [getCMSCollectionItemDetailsManifest.id]: getCMSCollectionItemDetailsManifest,
  [getPageMetadataManifest.id]: getPageMetadataManifest,
  [getSiteInfoManifest.id]: getSiteInfoManifest,
  [listCMSCollectionItemsManifest.id]: listCMSCollectionItemsManifest,
  [listCMSCollectionsManifest.id]: listCMSCollectionsManifest,
  [listPagesManifest.id]: listPagesManifest,
  [listTargetLanguagesManifest.id]: listTargetLanguagesManifest,
  [listTranslationExclusionsManifest.id]: listTranslationExclusionsManifest,
  [bulkUpdateTranslationExclusionsManifest.id]:
    bulkUpdateTranslationExclusionsManifest,
  [updateAllMatchingTranslationExclusionsManifest.id]:
    updateAllMatchingTranslationExclusionsManifest,
  [deleteAllMatchingTranslationExclusionsManifest.id]:
    deleteAllMatchingTranslationExclusionsManifest,
  [listSiteComponentsManifest.id]: listSiteComponentsManifest,
  [getComponentPropertiesManifest.id]: getComponentPropertiesManifest,
  [listWebhooksManifest.id]: listWebhooksManifest,
  [publishCMSCollectionItemsManifest.id]: publishCMSCollectionItemsManifest,
  [readReferenceFileManifest.id]: readReferenceFileManifest,
  [searchKnowledgeBaseManifest.id]: searchKnowledgeBaseManifest,
  [updateCMSCollectionManifest.id]: updateCMSCollectionManifest,
  [updateCMSCollectionFieldManifest.id]: updateCMSCollectionFieldManifest,
  [updateCMSCollectionItemsManifest.id]: updateCMSCollectionItemsManifest,
  [updatePageMetadataManifest.id]: updatePageMetadataManifest,
  [searchVariablesManifest.id]: searchVariablesManifest,
};
